/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Checkbox, Flex, Label, Text } from '@leverege/ui-elements';
import { UserSettings } from '@leverege/ui-redux';
import C from '../Constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PendingSaleMessageQuestion({
  saleType,
  state: pState,
  settings
}) {
  const [state, setState] = pState;
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colXL",
    children: [/*#__PURE__*/_jsxs(Text, {
      variant: "boldSmall",
      children: [/*#__PURE__*/_jsx("b", {
        children: `Your ${C.SALE_TYPE_NAMES[saleType]} is complete.`
      }), " Would you like to send an SMS message to any person with details about this sale?"]
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      children: [/*#__PURE__*/_jsx(Checkbox, {
        value: state?.pendingSaleMessageQuestionDisabled,
        onChange: ({
          value
        }) => setState(s => ({
          ...s,
          pendingSaleMessageQuestionDisabled: value
        }))
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "colS",
        children: [/*#__PURE__*/_jsx(Label, {
          variant: "inputTitle",
          children: "Don't show me this again"
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputCaption",
          children: "If you change your mind, you can send an SMS via the action menu on the Sales page."
        })]
      })]
    })]
  });
}
export default connect(state => ({
  settings: UserSettings.get(state, 'recovr.pendingSaleMessage', {
    returnPromise: true
  })
}))(PendingSaleMessageQuestion);